import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { DateUtil, getLongDate, getStringDate } from 'src/app/common/util';
import { ProductionService } from 'src/app/services/production.service';
import { AuthenticationService } from '../../../authentication/authentication/authentication.service';
import { ResponseObject } from 'src/app/models/response-object.model';
import { HttpErrorResponse } from '@angular/common/http';
import { ProductionResponse } from 'src/app/models/production';

@Component({
  selector: 'app-history-production',
  templateUrl: './history-production.component.html',
  styleUrls: ['./history-production.component.scss']
})
export class HistoryProductionComponent implements OnInit {
  startDate = '';
  endDate = '';
  type = 0;
  todayDate = new Date();
  reportList: ProductionResponse[] = [];
  pagination = {
    total: [],
    filter: [],
    pageSize: 10,
    startElement: 0,
    lastElement: 0,
    pageIndex: 0
  }
  loading = false;

  userId = null;
  seeingAll = false;
  companyName = "";
  currentCompany = null;
  waitingFor = false;
  filterWord = ""
  detailing: { [key: number]: boolean } = {};

  constructor(
    private toastService: ToastrService,
    private productionService: ProductionService,
    private authService: AuthenticationService,
  ) {
    const today = new Date();
    this.endDate = getStringDate(today);
    this.startDate = getStringDate(today);
    this.userId = JSON.parse(authService.getCurrentUser()).id;
    var permissions = authService.getPermissions();
    var getUserPosition = authService.getUserPosition();
    if (permissions) {
      for (let i = 0; i < permissions.length; i++) {
        const element = permissions[i];
        if (element.roleId == 5033 && element.read) {
          this.seeingAll = true;
          break;
        }
      }
    }

    this.currentCompany = JSON.parse(authService.getCurrentCompany());
    this.companyName = this.currentCompany.companyName;
  }

  ngOnInit(): void {
    this.changeType();
  }

  changeType() {
    const today = new Date();
    switch (parseInt(this.type + "")) {
      case 0:
        {
          this.endDate = getStringDate(today);
          this.startDate = getStringDate(today);
          break;
        }
      case 1:
        {
          this.endDate = getStringDate(today);
          today.setDate(today.getDate() - 7)
          this.startDate = getStringDate(today);
          break;
        }
      case 2:
        {
          this.endDate = getStringDate(today);
          today.setDate(1)
          this.startDate = getStringDate(today);
          break;
        }
      case 3:
        {
          const firstDayLastMonth = new Date(today.getFullYear(), today.getMonth() - 1, 1);
          const lastDayLastMonth = new Date(today.getFullYear(), today.getMonth(), 0);

          this.startDate = getStringDate(firstDayLastMonth);
          this.endDate = getStringDate(lastDayLastMonth);
          break;
        }
      case 4:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 2);
          this.startDate = getStringDate(today);
          break;
        }
      case 5:
        {
          this.endDate = getStringDate(today);
          today.setMonth(today.getMonth() - 3);
          this.startDate = getStringDate(today);
          break;
        }
    }
    this.getReportByIntervalDate();
  }

  changeDate() {
    if (this.startDate && this.endDate) {
      var tempStart = new Date(this.startDate);
      var tempEnd = new Date(this.endDate);
      if (tempStart > this.todayDate || tempEnd > this.todayDate) {
        this.toastService.info("No puedes ingresar fechas más allá del día de hoy");
      } else {
        if (tempStart > tempEnd) {
          this.toastService.info("La fecha de inicio debe ser más lejana que la de final");
        } else {
          this.getReportByIntervalDate();
        }
      }
    }
  }

  getReportByIntervalDate() {
    console.log(this.startDate, getLongDate(this.startDate));
    console.log(this.endDate, getLongDate(this.endDate));

    this.loading = true;
    this.productionService.getReportProductions(getLongDate(this.startDate), getLongDate(this.endDate)).subscribe({
      next: (response: ResponseObject) => {
        this.reportList = response.data;
        this.pagination.total = this.reportList;
        this.resetPagination();
        this.loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.toastService.error("Error al obtener el reporte", "Error");
        this.loading = false;
      }
    });
  }

  resetPagination() {
    if (this.filterWord != null && this.filterWord != "") {
      this.pagination.total = this.reportList.filter((r) => {
        return (r.productionProcess.name.toLowerCase()).includes(this.filterWord.toLowerCase())
      });
    }

    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  searching() {
    this.pagination.total = this.reportList.filter((r) => {
      return (r.productionProcess.name.toLowerCase()).includes(this.filterWord.toLowerCase())
    });
    this.pagination.filter = this.pagination.total.slice(0, this.pagination.pageSize);
    this.pagination.pageIndex = 0;
    this.pagination.lastElement = this.pagination.filter.length;
    this.pagination.startElement = 0;
  }

  convertToString(date: number) {
    if (!date) {
      return '';
    }
    var tempDate = new Date(date);
    return DateUtil.formatTimestamp(date);
  }

  showDetail(item: ProductionResponse) {
    this.detailing[item.production.id]= !this.detailing[item.production.id]
  }
}
